export enum State {
	PREQUERY_ERROR = 'PREQUERY_ERROR',
	PREQUERY_LOADING = 'PREQUERY_LOADING',
	PREQUERY_NO_RESULTS = 'PREQUERY_NO_RESULTS',
	PREQUERY_RESULTS = 'PREQUERY_RESULTS',
	POSTQUERY_ERROR = 'POSTQUERY_ERROR',
	POSTQUERY_LOADING = 'POSTQUERY_LOADING',
	POSTQUERY_NO_RESULTS = 'POSTQUERY_NO_RESULTS',
	POSTQUERY_RESULTS = 'POSTQUERY_RESULTS',
}
